import PhotoDocument from './PhotoDocument';

export default PhotoDocument;
